<template>
  <div class="row">
    <div class="col-lg-12">
      <b-card header="<i class='fa fa-align-justify'></i> List Pengajuan Izin">
        <form action="#/sppbmcp/listsppbmcp">

          <div role="group" class="form-group row">
            <div class="col-4">
              <div role="group" class="input-group">
                <input placeholder="Pencarian" class="form-control" type="text" v-model="q">
                <div class="input-group-btn">
                  <button type="submit" @click="getBrows()" class="btn btn-outline-primary"><i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-4">

            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-12">
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-bordered table-hover table-sm">
              <thead>
                <tr>
                  <th class="d-none d-md-block">NO SPPBMCP Kolektif</th>
                  <th>Tgl. SPPBMCP Kolektif</th>
                  <th>Jumlah CN</th>
                  <th class="d-none d-sm-block">Kode Billing</th>
                  <th>Total</th>
                  <th>Tgl. Jatuh Tempo</th>
                </tr>
              </thead>
              <tbody v-for="browse in brows.data">
                <tr>
                  <td>{{ browse.NO_SPPBMCP_KOL }}</td>
                  <td>{{ browse.TGL_SPPBMCP_KOL }}</td>
                  <td>{{ browse.JMLCN }}</td>
                  <td>{{ browse.KD_BILLING }}</td>
                  <td>{{ browse.TOTAL.toLocaleString() }}</td>
                  <td>{{ browse.TGL_JATUH_TEMPO }}</td>
                  <td>
                    <!-- <a :href="'http://localhost/backper/public/api/sppbmcp/download/'+browse.ID_SPPBMCP"><button type="button" @click="getDownload()" class="btn btn-success"name="button"> <i class="fa fa-download"></i> </button></a> -->
                    <div class="inline">
                      <!-- <form class="" @submit.prevet="download()" method="post">
                        <input type="hidden" name="id" v-model="browse.ID_SPPBMCP"> -->
                      <!-- <a :href="'http://perijinanbcbatam.beacukai.go.id/backper/public/api/sppbmcp/download/'+browse.ID_SPPBMCP"><button type="button" @click="" class="btn btn-success"name="button"> <i class="fa fa-download"></i> </button></a> -->
                      <button type="submit" @click="getDownload(browse.ID_SPPBMCP)" class="btn btn-success"> <i
                          class="fa fa-download"></i>
                      </button>
                      <button type="button" class="btn btn-primary" @click="setActiveRow(browse.ID_SPPBMCP)"
                        name="button"> <i class="fa fa-search"></i> </button>
                      <!-- </form> -->
                    </div>
                  </td>
                </tr>
                <tr v-if="isClicked === browse.ID_SPPBMCP">
                  <td colspan="7">
                    <table width="max">
                      <tr>
                        <th>NO Aju</th>
                        <th>NPWP</th>
                        <th>No. SPPBMCP</th>
                        <th>Tgl. SPPBMCP</th>
                        <th>Bea Masuk</th>
                        <th>PPN</th>
                        <th>PPH</th>
                        <th>PPNBM</th>
                        <th>BMTP</th>
                        <th>TOTAL</th>
                        <th>No. Barang</th>
                        <th>Tgl. House BL/AWB</th>
                        <th>Kode Gudang</th>
                        <th>No. Kantong</th>
                        <th>Kode PIBK</th>
                      </tr>
                      <tr v-for="tes in browsdtl.data">
                        <td>{{ tes.ID_AJU }}</td>
                        <td>{{ tes.ID_PEMBERITAHU }}</td>
                        <td>{{ tes.NO_SPPBMCP }}</td>
                        <td>{{ tes.TGL_SPPBMCP }}</td>
                        <td>{{ tes.TOTAL_BM }}</td>
                        <td>{{ tes.TOTAL_PPN }}</td>
                        <td>{{ tes.TOTAL_PPH }}</td>
                        <td>{{ tes.TOTAL_PPNBM }}</td>
                        <td>{{ tes.TOTAL_BMTP }}</td>
                        <td>{{ tes.TOTAL_TAGIHAN }}</td>
                        <td>{{ tes.NO_BARANG }}</td>
                        <td>{{ tes.TGL_HOUSE_BLAWB }}</td>
                        <td>{{ tes.KD_GUDANG }}</td>
                        <td>{{ tes.NO_KANTONG }}</td>
                        <td>{{ tes.KD_JNS_PIBK }}</td>
                      </tr>
                    </table>
                    <div class="pagination">
                      <button class="btn btn-secondary" @click="getBrowsDtl(id_current, browsdtl.first_page_url)"
                        :disabled="!browsdtl.prev_page_url">
                        &laquo;
                      </button>
                      <button class="btn btn-secondary" @click="getBrowsDtl(id_current, browsdtl.prev_page_url)"
                        :disabled="!browsdtl.prev_page_url">
                        &lsaquo;
                      </button>
                      <!--button class="btn btn-primary">{{ brows.current_page }} / {{ brows.last_page }} </button-->
                      <div>{{ browsdtl.current_page + '/' + browsdtl.last_page }}</div>
                      <button class="btn btn-secondary" @click="getBrowsDtl(id_current, browsdtl.next_page_url)"
                        :disabled="!browsdtl.next_page_url">
                        &rsaquo;
                      </button>
                      <button class="btn btn-secondary" @click="getBrowsDtl(id_current, browsdtl.last_page_url)"
                        :disabled="!browsdtl.next_page_url">
                        &raquo;
                      </button>

                      <!-- <div class="col-md-6" style="padding-left:50px">
                        <select class="form-control form-control-sm" v-model="c" @change="getBrows()">
                          <option value="">Sort by</option>
                          <option value="perijinan.td_permohonan.tgl_mohon" >Tanggal Mohon</option>
                          <option value="perijinan.td_permohonan.wk_kirim" >Tanggal Kirim</option>
                          <option value="perijinan.td_permohonan.tgl_setuju" >Tanggal Setuju</option>
                        </select>
                      </div> -->
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12">
          <div class="pagination">
            <button class="btn btn-primary" @click="getBrows(brows.first_page_url)" :disabled="!brows.prev_page_url">
              &laquo;
            </button>
            <button class="btn btn-primary" @click="getBrows(brows.prev_page_url)" :disabled="!brows.prev_page_url">
              &lsaquo;
            </button>
            <!--button class="btn btn-primary">{{ brows.current_page }} / {{ brows.last_page }} </button-->
            <div><input :placeholder="brows.current_page + '/' + brows.last_page" class="form-control"
                style="text-align:center;" type="text" @change="getBrows('bc/brows/browslist?page=' + p)" v-model="p"
                size="2"></div>
            <button class="btn btn-primary" @click="getBrows(brows.next_page_url)" :disabled="!brows.next_page_url">
              &rsaquo;
            </button>
            <button class="btn btn-primary" @click="getBrows(brows.last_page_url)" :disabled="!brows.next_page_url">
              &raquo;
            </button>

            <!-- <div class="col-md-6" style="padding-left:50px">
              <select class="form-control form-control-sm" v-model="c" @change="getBrows()">
                <option value="">Sort by</option>
                <option value="perijinan.td_permohonan.tgl_mohon" >Tanggal Mohon</option>
                <option value="perijinan.td_permohonan.wk_kirim" >Tanggal Kirim</option>
                <option value="perijinan.td_permohonan.tgl_setuju" >Tanggal Setuju</option>
              </select>
            </div> -->
          </div>
        </div>


      </b-card>
    </div>
    <b-modal hide-footer title="Catatan Petugas" size="lg" v-model="ModalCatatan" @ok="ModalCatatan = false">
      <div class="row">
        <div class="col-12">
          <table class="table table-bordered table-sm">
            <thead>

            </thead>
            <tbody>

            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
// import swal from 'sweetalert'
export default {
  data () {
    return {
      ModalCatatan: false,
      user: this.$store.getters['auth/user']['username'],
      npwp: this.$store.getters['auth/user']['npwp'],
      brows: [],
      browsdtl: [],
      catatan: [],
      id_current: '',
      q: '',
      p: '',
      isClicked: '',
      items: [
        {
          name: 'husni',
          surname: 'muhamad',
          explanation: 'gak ada',
          desc: 'gitu deh'
        },
        {
          name: 'husni',
          surname: 'muhamad',
          explanation: 'gak ada',
          desc: 'gitu deh'
        }
      ]
    }
  },
  created () {
    this.getBrows()
  },
  methods: {
    getBrows (page) {
      if (typeof page === 'undefined') {
        page = 'sppbmcp/list?page=1'
      }
      var auth = {
        user: this.$store.getters['auth/user']['username'],
        q: this.q,
        p: this.p,
        a: this.a,
        b: this.b,
        npwp: this.npwp
      }
      this.$http.post(page, auth)
        .then(response => {
          this.brows = response.data
          // swal(response.data.status, response.data.message, response.data.status)
        })
    },
    getDownload (id) {
      var auth = {
        id: id
      }
      this.$http.post('sppbmcp/download', auth, { responseType: 'blob' }).then(res => {
        let blob = new Blob([res.data], { type: res.headers['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'] })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.setAttribute('download', 'file.xlsx')
        // link.download = id.slice(id.lastIndexOf('/') + 1)
        link.click()
      })
    },
    getBrowsDtl (id, page) {
      this.id_current = id
      if (typeof page === 'undefined') {
        page = 'sppbmcp/listdtl?page=1'
      }
      var auth = {
        id: id
      }
      this.$http.post(page, auth)
        .then(response => {
          this.browsdtl = response.data
          // swal(response.data.status, response.data.message, response.data.status)
        })
    },
    setActiveRow (index) {
      this.browsdtl = []
      if (this.isClicked === index) {
        this.isClicked = ''
      } else {
        this.isClicked = index
        this.getBrowsDtl(index)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/SPPBMCP/listsppbmcp.vue?384736ac